/* eslint-disable no-unused-vars */
import http from '../../services/http';
import { setActivitiesLoader } from '../ui/loaders';
const path = 'api/create';

const book = ({ onSuccess, onError, onEnd, body = {} }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path + ``,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const editBlock = ({ onSuccess, onError, onEnd, body = {}, id = '', route = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/${route}/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const createChapter = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/chapter`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const createSection = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/section`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const createParagraph = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/paragraph`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const deleteParagraph = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/media-paragraph`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const reOrderChapters = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/chapter/reorder`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const savedLastVisitBook = ({ bookId, body, onSuccess, onError, onEnd }) => {
  return async (dispatch, getState) => {
    dispatch(setActivitiesLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/addopenbook/${bookId}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      dispatch(setActivitiesLoader(false));
    } finally {
      if (onEnd) onEnd();
      dispatch(setActivitiesLoader(false));
    }
  };
};
const reOrderSections = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/section/reorder`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const reOrderParagraph = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/paragragh/reorder`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const editBook = ({ onSuccess, onError, onEnd, body, id }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/book/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const deleteBlock = ({ onSuccess, onError, onEnd, id, route }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.delete({
        url: path + `/${route}/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const uploadMedia = ({ onSuccess, onError, onEnd, body }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/media`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body,
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export {
  book,
  editBlock,
  createChapter,
  createSection,
  createParagraph,
  deleteParagraph,
  reOrderChapters,
  reOrderParagraph,
  savedLastVisitBook,
  reOrderSections,
  editBook,
  uploadMedia,
  deleteBlock,
};
